import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Switch, Route } from 'react-router-dom'
import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/jelly.css'
import Spinner from './sitewide/Spinner'
import Dashboard from './Dashboard'
import Messages from './Messages'
import MessageSettings from './Settings'
import Patients from './PatientGroups/'
import PatientPage from './PatientPage'
import Schedule from './Schedule'
import { fetchCurrentUser } from '../state/actions/account'

const styles = {
  topsIndex: {
    zIndex: 2,
    position: 'relative',
  },
}

class TopsApp extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({
      username: PropTypes.string,
    }).isRequired,
    fetchCurrentUser: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { username } = this.props.currentUser

    if (!username) {
      this.props.fetchCurrentUser()
    }
  }

  render() {
    const { auth } = this.props

    if (auth.isFetching) {
      return <Spinner />
    }
    return (
      <div style={styles.topsIndex} id="topsIndex">
        <Switch>
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/messages" component={Messages} />
          <Route path="/patients" component={Patients} />
          <Route exact path="/patients/:id" component={PatientPage} />
          <Route path="/schedule" component={Schedule} />
          <Route path="/settings" component={MessageSettings} />
        </Switch>
        <Alert stack={{ limit: 3 }} />
      </div>
    )
  }
}


const mapStateToProps = ({ account }) => ({
  auth: account.auth,
  currentUser: account.user,
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({ fetchCurrentUser }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopsApp)



// WEBPACK FOOTER //
// ./src/components/TopsApp.js